import {
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  UPDATE_PW_USER_SUCCESS,
  UPDATE_PW_USER_FAIL,
  RESET_USER_STATE,
} from "./actionTypes"

const INIT_STATE = {
  user: [],
  userDetails: [],
  addUser: [],
  editUser: [],
  delUser: [],
  updatePw: [],
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      }

    case GET_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.payload,
      }

    case GET_USER_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USER_SUCCESS:
      return {
        ...state,
        addUser: action.payload,
        userDetails: action.payload.data,
      }

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        editUser: action.payload,
        userDetails: action.payload,
      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        delUser:  action.payload
      }

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PW_USER_SUCCESS:
      return {
        ...state,
        updatePw: action.payload
      }

    case UPDATE_PW_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_USER_STATE:
      return {
        ...state,
        addUser: [],
        userDetails: [],
        user: [],
        editUser: [],
        delUser: [],
        updatePw: [],
        error:[],
      }
    default:
      return state
  }
}

export default User
